var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.334 6.6665H6.66732C4.83398 6.6665 3.33398 8.1665 3.33398 9.99984V14.9998H6.66732V9.99984H33.334V14.9998H36.6673V9.99984C36.6673 8.1665 35.1673 6.6665 33.334 6.6665ZM33.334 29.9998H6.66732V24.9998H3.33398V29.9998C3.33398 31.8332 4.83398 33.3332 6.66732 33.3332H33.334C35.1673 33.3332 36.6673 31.8332 36.6673 29.9998V24.9998H33.334V29.9998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8173 12.5834C24.2507 11.4501 22.4007 11.4501 21.834 12.5834L16.6673 22.9334L14.8173 19.2501C14.6807 18.9737 14.4692 18.7413 14.2069 18.5793C13.9447 18.4172 13.6422 18.332 13.334 18.3334H3.33398V21.6667H12.3007L15.1673 27.4167C15.4673 27.9834 16.034 28.3334 16.6673 28.3334C17.3007 28.3334 17.8673 27.9834 18.1507 27.4167L23.334 17.0667L25.184 20.7501C25.4673 21.3167 26.034 21.6667 26.6673 21.6667H36.6673V18.3334H27.7007L24.8173 12.5834Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.f945ab0ca7daf5ce9b93830031b749d3.svg";
export { ForwardRef as ReactComponent };